export const DONATE_BUTTON_TEXT = 'Donate now';
export const LAST_UPDATE_TEXT = 'Last updated on';
export const DONATIONS_TEXT = 'donations';
